import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useDevice } from '../../context/DeviceContext';
import { useVirtualKeysSupport } from '../../utils/useVirtualKeysSupport';
import './Theme2Navigation.css';

const items = [
  { path: 'sensitivity', label: 'DPI设置' },
  { path: 'keys', label: '按键分配' },
  { path: 'macros', label: '宏' },
  { path: 'wheel', label: '滚轮', capability: 'wheelSettings' },
  { path: 'hits', label: '按键性能', capability: 'hitsSettings' },
  {
    path: 'virtual-keys',
    label: '虚拟按键',
    capability: 'hitsSettings',
    requireVirtualKeys: true,
  },
  {
    path: 'calibration',
    label: '行程校准',
    capability: 'hitsSettings',
    requireVirtualKeys: true,
  },
  { path: 'lighting', label: '灯光', capability: 'lightingSettings' },
  { path: 'firmware-update', label: '版本更新' },
  { path: 'advanced', label: '鼠标设置' },
];

export default function Theme2Navigation({ currentPath }) {
  const navigate = useNavigate();
  const { activeAdapter } = useDevice();
  const { visible: virtualKeysVisible } = useVirtualKeysSupport();
  const visibleItems = items.filter((item) => {
    if (
      item.capability &&
      activeAdapter?.capabilities?.[item.capability] !== true
    ) {
      return false;
    }
    if (item.requireVirtualKeys && !virtualKeysVisible) return false;
    return true;
  });

  return (
    <nav className="theme2-navigation" aria-label="主要功能">
      {visibleItems.map((item) => (
        <button
          type="button"
          key={item.path}
          className={`theme2-nav-item ${currentPath === item.path ? 'active' : ''}`}
          onClick={() => navigate(`/${item.path}`)}
        >
          <span>{item.label}</span>
        </button>
      ))}
    </nav>
  );
}
